import React from 'react';
import useStyles from './styles';
import { Typography } from '@material-ui/core';
import AppStoreBadgeImage from '@assets/appstore-badge.png';
import GooglePlayBadgeImage from '@assets/google-play-badge.png'
import SmartPhoneImage from '@assets/overview-courier-smartphone.png'
import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import JetButton from '@src/shared/components/JetButton';
import InitialAnimatedBackground from '../InitialAnimatedBackground';
import { useTranslation } from 'react-i18next';
const CourierInitialContent = (props: any) => {
  const classes = useStyles();
  const { isResolutionMobile } = useDeviceDetect();
  const { t } = useTranslation()
  return (
    <div className={classes.courierInitialContentContainer} id='main-initial-content-container'>
      {!isResolutionMobile && <InitialAnimatedBackground />}
      <div className={classes.courierInitialContent}>
      <Typography variant={isResolutionMobile ? `h3` : `h1`} className={`courier-initial-content-title ${isResolutionMobile ? `heading_l` : `heading_xxl`} `} align={isResolutionMobile ? 'left' : 'center'}>
          {t('new_productoverview_courier.section1_title')}
        </Typography>
        <Typography variant="body1" className={isResolutionMobile ? `body_regular` : `subheading_s`} align={isResolutionMobile ? 'left' : 'center'}>
        {t('new_productoverview_courier.section1_description')}
        </Typography>
        {!isResolutionMobile ? <div className='badge_holder'>
          <img onClick={props.onIosDownload} src={AppStoreBadgeImage} />
          <img onClick={props.onAndroidDownload} src={GooglePlayBadgeImage} />
        </div> :  <JetButton onClick={props.onAutoDetectDownload} size={isResolutionMobile ? 'medium' : 'large'} variation="primary">
        {t('new_productoverview_courier.common_download_now_button')}
        </JetButton>}
        <img className='smartphoneimage' src={SmartPhoneImage} />
      </div>
    </div>
  );
};

export default CourierInitialContent;
